;(function() {
  'use strict'

  angular.module('core.filters').filter('shortTimeAgo', shortTimeAgo)

  // --------------------

  function shortTimeAgo() {
    return function(date) {
      var now = moment()
      var then = moment(date)

      // now
      if (now.diff(then, 'minutes') < 5) {
        return 'Now'
        // minutes
      } else if (now.diff(then, 'minutes') < 60) {
        return now.diff(then, 'minutes') + 'm'
        // hours
      } else if (now.diff(then, 'hours') < 24) {
        return now.diff(then, 'hours') + 'h'
        // days
      } else {
        return now.diff(then, 'days') + 'd'
      }
    }
  }
})()
